import * as Msdyn365 from '@msdyn365-commerce/core';

interface VArticleIdsResponse {
    value: string[];
}

export async function getVArticleIds(articleIds: string[], ctx: Msdyn365.IActionContext): Promise<string[]> {
    const url = `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetVArticleIds`;

    try {
        const res = await Msdyn365.sendRequest(
            url,
            'post',
            { vArticleRequest: { ArticleIds: articleIds } },
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    OUN: ctx.requestContext.apiSettings.oun
                }
            }
        );

        const dataAny = res?.data;

        let list: unknown;

        if (Array.isArray(dataAny)) {
            list = dataAny;
        } else if (dataAny && typeof dataAny === 'object') {
            const obj = dataAny as Partial<VArticleIdsResponse> & { data?: VArticleIdsResponse; result?: VArticleIdsResponse };
            list = (obj.value as unknown) ?? (obj.data?.value as unknown) ?? (obj.result?.value as unknown);
        }

        const result = Array.isArray(list) ? list : [];

        return (result as unknown[])
            .filter((s): s is string => typeof s === 'string')
            .map(s => s.trim())
            .filter(s => s.length > 0);
    } catch {
        return [];
    }
}

export default getVArticleIds;
